<template>
  <screener-frame>
    <screener-title title="Previous Medical Diagnoses" />

    <common-toggle
      v-model="cpap.value"
      class="mb-4"
      :label="cpap.label"
    />
    <div class="body-1 font-weight-bold">
      Please check any conditions for
      which you have been medically diagnosed or treated.
    </div>

    <v-row>
      <v-col
        v-for="morbidity in coMorbidity"
        :key="morbidity.name"
        cols="12"
        md="6"
      >
        <common-toggle
          v-model="morbidity.value"
          :label="morbidity.label"
        />
      </v-col>
    </v-row>

    <template #actions>
      <v-spacer />

      <v-btn
        class="button-next"
        color="primary"
        @click="goNext"
      >
        Next
        <v-icon>mdi-chevron-double-right</v-icon>
      </v-btn>
    </template>
  </screener-frame>
</template>

<script>
import { cpap, coMorbidity } from '@/use/screener'
import { toastr, utils } from 'ui-common'

export default {
  setup: () => {
    const goNext = () => {
      if (cpap.value === null) {
        toastr.e(
          'Have you ever used CPAP before?',
          'Please answer the question'
        )
      } else {
        utils.navigate('/results')
      }
    }

    return {
      cpap,
      coMorbidity,

      goNext
    }
  }
}
</script>
